import apiClient, { API_BASE_URL } from './client';

export const lookupFellowshipCode = async (code) => {
    const response = await apiClient.get(`/api/v1/fellowship/lookup-code/${code}`);
    return response.data;
};

export const getMyFellowship = async () => {
    const response = await apiClient.get('/api/v1/fellowship/me');
    return response.data;
};

export const getFellowshipDashboard = async () => {
    const response = await apiClient.get('/api/v1/fellowship/dashboard');
    return response.data;
};

export const getMyReferrals = async (skip = 0, limit = 20) => {
    const response = await apiClient.get('/api/v1/fellowship/referrals', { params: { skip, limit } });
    return response.data;
};

export const getYomHistory = async (skip = 0, limit = 20) => {
    const response = await apiClient.get('/api/v1/fellowship/yom-history', { params: { skip, limit } });
    return response.data;
};

export const getStore = async () => {
    const response = await apiClient.get('/api/v1/fellowship/store');
    return response.data;
};

export const redeemProduct = async (productId) => {
    const response = await apiClient.post('/api/v1/fellowship/redeem', { product_id: productId });
    return response.data;
};

export const getMyRedemptions = async () => {
    const response = await apiClient.get('/api/v1/fellowship/redemptions');
    return response.data;
};

export const getMyTeam = async () => {
    const response = await apiClient.get('/api/v1/fellowship/my-team');
    return response.data;
};

export const searchInstructors = async (q) => {
    const response = await apiClient.get('/api/v1/fellowship/search-instructors', { params: { q } });
    return response.data;
};

export const createAssociate = async (userId) => {
    const response = await apiClient.post('/api/v1/fellowship/create-associate', { user_id: userId });
    return response.data;
};

export const requestLimitIncrease = async (requestedLimit, reason) => {
    const response = await apiClient.post('/api/v1/fellowship/request-limit-increase', { requested_limit: requestedLimit, reason });
    return response.data;
};

export const getMyLimitRequests = async () => {
    const response = await apiClient.get('/api/v1/fellowship/my-limit-requests');
    return response.data;
};

// ─── Public endpoints — raw fetch, no apiClient ───────────────────────────────
// apiClient attaches Bearer tokens and redirects 401 → /login, which breaks
// unauthenticated landing-page calls. Raw fetch avoids that entirely.
//
// PUBLIC_BASE reuses client.js's API_BASE_URL rather than re-deriving its own
// fallback: a bare `process.env.REACT_APP_API_URL || 'http://localhost:8000'`
// has no production-safe default, so on any build where that env var wasn't
// actually baked in, every real visitor's browser tried to fetch their own
// machine's localhost:8000 — silently failing for almost everyone (landing
// page fell back to static placeholder numbers) and, worse, silently
// SUCCEEDING with meaningless data for anyone who happened to have a local
// dev server running on that port.
const PUBLIC_BASE = API_BASE_URL;

export const getFellowOfTheDay = async () => {
    const res = await fetch(`${PUBLIC_BASE}/api/v1/public/fellow-of-the-day`);
    if (!res.ok) throw new Error('fellow-of-the-day fetch failed');
    return res.json();
};

export const getFellowshipStats = async () => {
    const res = await fetch(`${PUBLIC_BASE}/api/v1/public/fellowship-stats`);
    if (!res.ok) throw new Error('fellowship-stats fetch failed');
    return res.json();
};

// Not fellowship-specific — lives here because this is where the "public
// endpoints, raw fetch" convention already exists (see the block comment
// above). Used by the landing page's Statistics.js stat cards.
export const getPlatformStats = async () => {
    // cache:'no-store' + a cache-busting param so the landing-page counts always
    // reflect the live DB. Without this the browser could heuristically cache an
    // early response (e.g. a mid-migration count) and keep showing it even after
    // a hard refresh.
    const res = await fetch(`${PUBLIC_BASE}/api/v1/public/platform-stats?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) throw new Error('platform-stats fetch failed');
    return res.json();
};

export const submitJoinRequest = async (data) => {
    const res = await fetch(`${PUBLIC_BASE}/api/v1/fellowship/join-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'Failed to submit request');
    }
    return res.json();
};
